// import of a statemanager store. Adjust to meet component requirements.
import { useSearchStore } from 'stores/search.store'
import { onMounted, ref } from 'vue'


// Developer note: remove labels from props if it not needed in the component
export default {
    name: "SearchBar",
    props: {
        guid: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const searchStore = useSearchStore()
        const searchInput = ref(null)

        const handleKeyNavigation = function (e) {
           if (e.key === "Enter") {
            handleSearch()
           }
        }

        onMounted(() => {
            const url = window.location.search
            const urlParams = new URLSearchParams(url)
            const query = urlParams.get('q')

            if (query) {
                searchStore.setSearchQuery({ guid: props.guid, searchKey: "search", query })
            }
            
            searchStore.setSearchUrl({ 
                guid: props.guid, 
                searchKey: "search",
                url: process.env.LIST_SEARCH_LIST.replace("[guid]", props.guid)
            })
        })

        const handleSearch = function () {
            searchStore.setCurrentPage({ guid: props.guid, searchKey: "search", resetPage: true })
            searchStore.setSearchQuery({ guid: props.guid, searchKey: "search", query: searchInput.value.value })
            searchStore.performSearch({ guid: props.guid, searchKey: "search", replaceResults: true })
        }

        return {
            searchInput,
            handleKeyNavigation,
            handleSearch
        }
    }
}